var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg51(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4466_96805)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8324e-08 9.64062C5.8324e-08 10.8056 0.944425 11.75 2.10937 11.75H7.73437C8.89932 11.75 9.84375 10.8056 9.84375 9.64062V2.60938C9.84375 1.44443 8.89932 0.5 7.73437 0.5H2.10937C0.944425 0.5 5.8324e-08 1.44443 5.8324e-08 2.60938V9.64062ZM2.10937 10.3438C1.72107 10.3438 1.40625 10.0289 1.40625 9.64062V2.60938C1.40625 2.22107 1.72107 1.90625 2.10937 1.90625H7.73437C8.12267 1.90625 8.4375 2.22107 8.4375 2.60938V9.64062C8.4375 10.0289 8.12267 10.3438 7.73437 10.3438H2.10937Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8125 8.9375H4.21875V7.53125H4.92187C6.08682 7.53125 7.03125 6.58682 7.03125 5.42188C7.03125 4.25692 6.08682 3.3125 4.92187 3.3125H2.8125V8.9375ZM4.21875 6.125V4.71875H4.92187C5.31017 4.71875 5.625 5.03358 5.625 5.42188C5.625 5.81017 5.31017 6.125 4.92187 6.125H4.21875Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.625 23.7969V11.0469H4.21875V23.7969H5.625Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 23.0937H0V24.5H24V23.0937Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.125 21.6875H24V18.1719C24 17.0069 23.0556 16.0625 21.8906 16.0625H9.23437C8.06942 16.0625 7.125 17.0069 7.125 18.1719V21.6875ZM8.53125 20.2812V18.1719C8.53125 17.7836 8.84607 17.4687 9.23437 17.4687H21.8906C22.2789 17.4687 22.5937 17.7836 22.5937 18.1719V20.2812H8.53125Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5577 16.5433L21.4719 13.2861C21.1848 12.4248 20.3787 11.8438 19.4708 11.8438H11.6542C10.7462 11.8438 9.9402 12.4247 9.65306 13.286L8.56733 16.5433L9.90142 16.988L10.9871 13.7308C10.9871 13.7308 10.9871 13.7308 10.9871 13.7308C11.0829 13.4437 11.3516 13.25 11.6542 13.25H19.4708C19.7734 13.25 20.0421 13.4436 20.1379 13.7308C20.1379 13.7308 20.1379 13.7308 20.1379 13.7308L21.2236 16.988L22.5577 16.5433Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 23.7969V20.9844H11.3437V23.7969H12.75Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53125 20.9844V23.7969H9.9375V20.9844H8.53125Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5937 23.7969V20.9844H21.1875V23.7969H22.5937Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.375 20.9844V23.7969H19.7812V20.9844H18.375Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4466_96805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg51);
export default __webpack_public_path__ + "static/media/51.f15b2f5df47407025c2110e6307d0d5d.svg";
export { ForwardRef as ReactComponent };